// extracted by mini-css-extract-plugin
module.exports = {"otpStatus":"OtpStatus_otpStatus__2ycYP","spinner":"OtpStatus_spinner__lP7np","message":"OtpStatus_message__kQ6UV","error":"OtpStatus_error__1Qgyx"};